// frontend/app/plugins/cross-tab-auth.client.ts
export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  const channel = ('BroadcastChannel' in window)
    ? new BroadcastChannel('auth')
    : null
  ;(window as unknown as { __authChannel?: BroadcastChannel }).__authChannel = channel ?? undefined

  const handler = async (msg: { type: string, at?: number, expiresInSecs?: number }) => {
    const session = useSession()
    const authStore = useAuthStore()
    if (msg.type === 'logout') {
      authStore.reset()
      const router = useRouter()
      if (!router.currentRoute.value.meta.public) {
        await navigateTo('/login')
      }
    } else if (msg.type === 'login') {
      // force: our persisted actor is still empty, but the sibling tab's
      // login means fresh HttpOnly cookies exist — probe /me anyway.
      await session.bootstrap({ force: true })
    } else if (msg.type === 'refreshed') {
      // Sibling tab just rotated. HttpOnly cookies are shared across
      // same-origin tabs, so our cookies are already fresh. Update the
      // local 30 s guard and reschedule our idle timer from the
      // broadcast TTL — no /me round trip needed.
      if (typeof msg.at === 'number' && typeof msg.expiresInSecs === 'number') {
        session.noteSiblingRefresh(msg.at, msg.expiresInSecs)
      }
    }
  }

  channel?.addEventListener('message', e => void handler(e.data))

  if (!channel) {
    window.addEventListener('storage', (e) => {
      if (!e.key || !e.key.startsWith('auth:tick:')) return
      const type = e.key.slice('auth:tick:'.length)
      void handler({ type })
    })
  }
})
